// Helper chat interna: URL WebSocket, formattazione, suono notifica (Web Audio, nessun asset).
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const CHAT_SOUND_KEY = "crm_chat_sound";
export const ALL_CHANNEL = "all";

export function wsUrl() {
  return `${BACKEND.replace(/^http/, "ws")}/api/chat/ws`;
}

export function soundEnabled() {
  return localStorage.getItem(CHAT_SOUND_KEY) !== "0";
}

export function setSoundEnabled(on) {
  localStorage.setItem(CHAT_SOUND_KEY, on ? "1" : "0");
}

export function fmtTime(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" });
}

export function fmtDay(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const today = new Date();
  const sameDay = (a, b) => a.toDateString() === b.toDateString();
  if (sameDay(d, today)) return "Oggi";
  const y = new Date(today); y.setDate(today.getDate() - 1);
  if (sameDay(d, y)) return "Ieri";
  return d.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
}

let ctx = null;
function tone(freq, start, dur, gainV = 0.08) {
  const o = ctx.createOscillator();
  const g = ctx.createGain();
  o.type = "sine"; o.frequency.value = freq;
  g.gain.setValueAtTime(0, ctx.currentTime + start);
  g.gain.linearRampToValueAtTime(gainV, ctx.currentTime + start + 0.01);
  g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + start + dur);
  o.connect(g); g.connect(ctx.destination);
  o.start(ctx.currentTime + start); o.stop(ctx.currentTime + start + dur + 0.02);
}

export function playChatSound(important = false) {
  try {
    if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    if (important) { tone(880, 0, 0.14, 0.12); tone(1175, 0.16, 0.14, 0.12); tone(880, 0.32, 0.22, 0.12); }
    else { tone(740, 0, 0.12); tone(988, 0.13, 0.16); }
  } catch (e) { /* autoplay bloccato: ignora */ }
}
